import isEmpty from 'lodash/isEmpty';
import isFunction from 'lodash/isFunction';
import isNull from 'lodash/isNull';

import { on } from './event';
import {
    getState,
    setState,
    subscribeToStateChange,
} from './state';
import BetslipController from '../../legacy/modules/jsx/betslip/BetslipController';
import { isLargeContainer } from '~spa/Utils/ContainerSize';
import { getUserTaxOnReturns, isUserLoggedIn, getCustomerAcceptOddsFlag } from '~shared/utils/user';
import { post } from '~shared/utils/http';
import { buildSpectateUrl } from '~spa/Utils/Spectate';

/**
 * The betslip selection added event
 * @type {String}
 */
export const BETSLIP_SELECTION_ADDED_EVENT = 'betslip:selection:added';

/**
 * The betslip selection removed event
 * @type {String}
 */
export const BETSLIP_SELECTION_REMOVED_EVENT = 'betslip:selection:removed';

/**
 * The betslip selections removed event
 * @type {String}
 */
export const BETSLIP_SELECTIONS_REMOVED_EVENT = 'betslip:selections:removed';

/**
 * The betslip receipt shown event
 * @type {String}
 */
export const BETSLIP_BET_PLACED_EVENT = 'betslip:bet:placed';

/**
 * The bets placed successful event
 * @type {String}
 */
export const BETSLIP_BET_PLACED_SUCESSFUL_EVENT = 'betslip:bet:placed:sucessful';


/**
 * The betslip opened event
 * @type {String}
 */
export const BETSLIP_OPENED_EVENT = 'betslip:opened';

/**
 * The betslip closed event
 * @type {String}
 */
export const BETSLIP_CLOSED_EVENT = 'betslip:closed';

/**
 * The betslip empty event
 * @type {String}
 */
export const BETSLIP_EMPTY_EVENT = 'betslip:empty';

/**
 * The betslip placement shwon event
 * @type {String}
 */
export const BETSLIP_PLACEMENT_SHOWN_EVENT = 'betslip:placement:shown';

/**
 * The betslip placement shwon event
 * @type {String}
 */
export const BETSLIP_RECEIPT_SHOWN_EVENT = 'betslip:receipt:shown';

/**
 * The betslip before sync event
 * @type {String}
 */
export const BETSLIP_BEFORE_SYNC_EVENT = 'betslip:before:sync';

/**
 * The betslip after sync event
 * @type {String}
 */
export const BETSLIP_AFTER_SYNC_EVENT = 'betslip:after:sync';

/**
 * Open bets on betslip launch event
 * @type {String}
 */
export const BETSLIP_OPENBETS_LAUNCH_EVENT = 'betslip:openbets:launch';

/**
 * Open bets on betslip destroy event
 * @type {String}
 */
export const BETSLIP_OPENBETS_DESTROY_EVENT = 'betslip:openbets:destroy';

/**
 * The betslip element ID
 * @type {String}
 */
export const BETSLIP_CSS_ID = 'betslip';

/**
 * The betslip selections element ID
 * @type {String}
 */
export const BETSLIP_SELECTIONS_CSS_ID = 'betslip-selections-list';

/**
 * The betslip placement element ID
 * @type {String}
 */
export const BETSLIP_PLACEMENT_CSS_ID = 'betslip-placement';

/**
 * The betslip receipt element ID
 * @type {String}
 */
export const BETSLIP_RECEIPT_CSS_ID = 'betslip-receipt';

/**
 * The betslip placement element ID
 * @type {String}
 */
export const BB_MODAL_CURRENT_PAGE_CSS_CLASS_NAME = 'bb-modal-current-page';

/**
 * The betslip placement element css class name
 * @type {String}
 */
export const BB_MODAL_VISIBLE_CSS_CLASS_NAME = 'bb-modal-visible';

/**
 * The betslip desktop launch element CSS active class name
 * @deprecated
 * @type {String}
 */
export const BETSLIP_DESKTOP_LAUNCH_ACTIVE_CSS_CLASS_NAME = 'active';

/**
 * The betslip launchpoint container element CSS ID
 * @type {String}
 */
export const BETSLIP_LAUNCHPOINT_CONTAINER_CSS_ID = 'betslip-mobile-container';

export const BETSLIP_SELECTIONS_DETAILS_KEY = 'betslip:selections:details';

export const BETSLIP_USER_BETSLIP_KEY = 'betslip:user:betslip';

export const BETSLIP_AVAILABLE_BET_TYPES_KEY = 'betslip:available-bet-types';

export const BETSLIP_CONTINGENCIES_KEY = 'betslip:contingencies';

export const BETSLIP_AVAILABLE_FREEBETS_KEY = 'betslip:available-free-bets';

export const BETSLIP_ON_OPEN_BETS_PAGE_KEY = 'betslip:on-open-bets-page';

export const BETSLIP_STARTUP_MY_BETS_KEY = 'betslip:startup:my_bets';

export const BETSLIP_POPULATE_SELECTIONS = 'betslip:populate:selections';

export const BETSLIP_POPULATE_SURVEY_ID = 'betslip:populate:survey-id';

export const COOKIE_BANNER_VISIBILITY_STATE_KEY = 'wrapper:cookie-banner-visibility';

/**
 * Sports that are considered racing sports. Only for use in the legacy BetslipController
 */
export const BETSLIP_RACING_SPORTS = ['horse-racing', 'greyhound-racing', 'trotting'];

/**
 * Gets selections from betslip
 * @return {Object} selections in betslip
 */
export const getBetslipSelections = () => {
    const defaultSelectionsDetails = {};
    const selectionsDetails = getState(BETSLIP_SELECTIONS_DETAILS_KEY);

    return selectionsDetails || defaultSelectionsDetails;
};

export const hideBetslipLoadingSpinner = () => {
    if (isFunction(BetslipController.hideLoadingSpinner)) {
        BetslipController.hideLoadingSpinner();
    }
};

/**
 * Gets betslip selection ids
 * @return {Array} selection ids
 */
export const getBetslipSelectionIds = () => {
    return Object.keys(getBetslipSelections());
};

/**
 * Gets the betslip dom element
 * @return {Element} The dom element
 */
export const getBetslipDomElement = () => {
    return document.getElementById(BETSLIP_CSS_ID);
};

/**
 * Gets the betslip dom element
 * @return {Element} The dom element
 */
export const getBetslipSelectionsDomElement = () => {
    return document.getElementById(BETSLIP_SELECTIONS_CSS_ID);
};

/**
 * Gets the betslip launchpoint container dom element
 * @return {Element} The dom element
 */
export const getBetslipLaunchpointContainer = () => {
    return document.getElementById(BETSLIP_LAUNCHPOINT_CONTAINER_CSS_ID);
};

/**
 * Checks if the betslip is empty
 * @return {Boolean} Returns true if there are no selections in the betslip
 */
export const isBetslipEmpty = () => {
    return isEmpty(getBetslipSelectionIds());
};

/**
 * Returns a list of event ids for the selections in the betslip
 * Was used by the inplay page to revent unsubscription from WS updates, but since
 * AM-2575 this is no longer relevant. Can we deprecate?
 * @return {Array} A list of event ids
 */
export const getBetslipEventIds = () => {
    const selections = getBetslipSelections();
    const events = new Set();

    Object.keys(selections).forEach((selectionId) => {
        events.add(selections[selectionId].event_id);
    });

    return Array.from(events);
};

/**
 * Checks if selection is in betslip
 * @param {String} selectionId selection id
 * @return {boolean} boolean
 */
export const betslipHasSelection = (selectionId) => {
    return getBetslipSelections().hasOwnProperty(selectionId);
};

/**
 * Registers a callback to listen to when selections are added to the betslip
 * @param {Function} callback The function called when a selection is added to the betslip
 * It receives an object with the selection details e.g selection.id
 * @return {Function} An unsubscribe function
 */
export const onSelectionAddedToBetslip = (callback) => {
    return on(BETSLIP_SELECTION_ADDED_EVENT, callback);
};

/**
 * Registers a callback to listen to when selections are removed from the betslip
 * @param {Function} callback The function called when a selection is removed from the betslip
 * It receives an object with the selection details e.g selection.id
 * This event is emitted BEFORE the betslip has been synced with the backend and the selection
 * might still be reported as nbeing in the betslip if you use function which rely on querying
 * the BetslipController global object, e.g. betslipHasSelection().
 * @return {Function} An unsubscribe function
 */
export const onSelectionRemovedFromBetslip = (callback) => {
    return on(BETSLIP_SELECTION_REMOVED_EVENT, callback);
};

/**
 * Registers a callback to listen to when selections are removed from the betslip
 * @param {Function} callback The function called when a selections are removed from the betslip
 * It receives an object with the selections, {selectionIds: []}
 * This event is emitted after the betslip has been synced with the backend.
 * @return {Function} An unsubscribe function
 */
export const onSelectionsRemovedFromBetslip = (callback) => {
    return on(BETSLIP_SELECTIONS_REMOVED_EVENT, callback);
};

/**
 * Registers a callback to listen to when bets have been placed
 * @param {Function} callback The function called when a bet has been placed
 * It receives an object with the betslip selection details
 * @return {Function} An unsubscribe function
 */
export const onBetPlaced = (callback) => {
    return on(BETSLIP_BET_PLACED_EVENT, callback);
};

/**
 * Gets user betslip
 * @return {Object} user's betslip
 */
export const getUserBetslip = () => {
    return getState(BETSLIP_USER_BETSLIP_KEY) || {
        originalPrices: {},
        betLocateArray: {},
    };
};

/**
 * Gets selections order
 * @return {Object} selections order
 */
export const getSelectionsOrder = () => {
    return getUserBetslip().selectionsOrder || [];
};

/**
 * Registers a callback to listen to when bets have been placed successful
 * @param {Function} callback The function called when a bet has been placed
 * It receives an object with the betslip selections details
 * @return {Function} An unsubscribe function
 */
export const onBetPlacedSuccessful = (callback) => {
    return on(BETSLIP_BET_PLACED_SUCESSFUL_EVENT, callback);
};

/**
 * Registers a callback to listen to when the betslip is opened
 * @param {Function} callback The callback function
 * @return {Function} An unsubscribe function
 */
export const onBetslipOpened = (callback) => {
    return on(BETSLIP_OPENED_EVENT, callback);
};

/**
 * Registers a callback to listen to when the betslip is closed
 * @param {Function} callback The callback function
 * @return {Function} An unsubscribe function
 */
export const onBetslipClosed = (callback) => {
    return on(BETSLIP_CLOSED_EVENT, callback);
};

/**
 * Registers a callback to listen to when the betslip placement is shown.
 * N.B. the betslip might not be visible (e.g. if in mobile view)
 * @param {Function} callback The callback function
 * @return {Function} An unsubscribe function
 */
export const onBetslipPlacementShown = (callback) => {
    return on(BETSLIP_PLACEMENT_SHOWN_EVENT, callback);
};

/**
 * Registers a callback to listen to when the betslip placement is shown.
 * E.g. after bet placement
 * @param {Function} callback The callback function
 * @return {Function} An unsubscribe function
 */
export const onBetslipReceiptShown = (callback) => {
    return on(BETSLIP_RECEIPT_SHOWN_EVENT, callback);
};

/**
 * Registers a callback to listen to when the betslip becomes empty
 * @note The betslip might be in a state of removing a selection
 * which is an async operation, so do not rely on this but listen to
 * the onBetslipEmpty callback if you also want to catch async betslip
 * selection updates
 * @param {Function} callback The callback function
 * @return {Function} An unsubscribe function
 */
export const onBetslipEmpty = (callback) => {
    return on(BETSLIP_EMPTY_EVENT, callback);
};

/**
 * Registers a callback to listen to when the betslip is about to be synced
 * The callback receives an object with the userBetslip as a property
 * @param {Function} callback The callback function
 * @return {Function} An unsubscribe function
 */
export const onBeforeBetslipSync = (callback) => {
    return on(BETSLIP_BEFORE_SYNC_EVENT, callback);
};

/**
 * Registers a callback to listen to when the betslip has been synced
 * @param {Function} callback The callback function
 * @return {Function} An unsubscribe function
 */
export const onAfterBetslipSync = (callback) => {
    return on(BETSLIP_AFTER_SYNC_EVENT, callback);
};

/**
 * Checks if the betslip open
 * @return {Boolean} Returns true if the betslip  is open
 */
export function isBetslipOpen() {
    if (isLargeContainer()) {
        return true;
    }

    const betslipEl = getBetslipDomElement();

    if (betslipEl === null) {
        return false;
    }

    return betslipEl.classList.contains(BB_MODAL_VISIBLE_CSS_CLASS_NAME);
}

/**
 * Checks if the betslip placement is currently open
 * @return {Boolean} Returns true if the betslip placement is open
 */
export function isBetslipPlacementOpen() {
    const betslipPlacementEl = document.getElementById(BETSLIP_PLACEMENT_CSS_ID);

    if (betslipPlacementEl === null) {
        return false;
    }

    return betslipPlacementEl.classList.contains(BB_MODAL_CURRENT_PAGE_CSS_CLASS_NAME);
}

/**
 * Checks if the betslip receipt is currently open
 * @return {Boolean} Returns true if the betslip receip is open
 */
export function isBetslipReceiptOpen() {
    const betslipReceiptEl = document.getElementById(BETSLIP_RECEIPT_CSS_ID);

    if (betslipReceiptEl === null) {
        return false;
    }

    return betslipReceiptEl.classList.contains(BB_MODAL_CURRENT_PAGE_CSS_CLASS_NAME);
}

/**
 * Returns the available bet types
 * @return {Array} The available bet types
 */
export function getAvailableBetTypes() {
    return getState(BETSLIP_AVAILABLE_BET_TYPES_KEY) || [];
}

/**
 * Save the available bet types
 * @param {Array} betTypes list of availableBetTypes
 * @returns {void}
 */
export const setAvailableBetTypes = (betTypes) => {
    setState(BETSLIP_AVAILABLE_BET_TYPES_KEY, betTypes);
};

/**
 * Returns the related contingencies
 * @return {Array} The related contingencies
 */
export function getContingencies() {
    return getState(BETSLIP_CONTINGENCIES_KEY) || [];
}

/**
 * Returns the available free bets
 * @return {Object} The available free bets
 */
export function getAvailableFreeBets() {
    return getState(BETSLIP_AVAILABLE_FREEBETS_KEY) || {};
}

/**
 * Returns the total amount of suspended selections
 * @returns {Number} The amount
 */
export function getTotalSuspendedSelections() {
    return BetslipController.getTotalSuspendedSelections();
}

/**
 * This function is needed for the way the decimals (stake, return,
 * etc) are computed on the server.
 * This function rounds a number to the format used by the
 * server. It should be called after each operation on the number.
 * @param {Number} n the number to round
 * @returns {Number} The rounded number to the second decimal
 */
export const bsNumber = n => Math.round(n * 100) / 100;

/**
 * Calculates the potential returns for a single
 * @param {Object} selection The selection object
 * @returns {Number} The potential return
 */
export function calculateSingleBetPotentialReturn(selection) {
    return BetslipController.calculateSingleBetPotentialReturn(selection);
}

/**
* calculate the potential return for one or many multibets
* @param {Object} stakes
* eg: {
*   singles: [
*       {
*            price: 2,
*            stake: 1,
*            eachWay: { isSet: true, divisor: 1.02}
*        }
*    ],
*    multiples: [
*        {
*            type: 1,
*            stake: 1,
*            isEachWay: true
*        }
*    ]
* }
* @param {Array} relatedContingencies eg: [[123, 569], [7896, 56, 87]] (set of related contingencies bets)
* @return {Float} potentialReturn
*/
export function calculateMultiBetsPotentialReturn(stakes, relatedContingencies) {
    return BetslipController.calculateMultiBetsPotentialReturn(stakes, relatedContingencies);
}

/**
 * Sync each way state between baby bs and bs
 * @param {Object} data The selections data
 * @returns {Boolean|void} False on error, void on success
 */
export function updateEwSelectionState(data) {
    return BetslipController.updateEwSelectionState(data);
}

/**
 * Place a bet from external source (BabyBetslip)
 * @param {String} type Type of bet - single/multi
 * @param {Object} data Bet data
 * @param {Boolean} loggedIn Whether the user is logged in
 * @returns {void}
 */
export function betExternal(type, data, loggedIn) {
    return BetslipController.betExternal(type, data, loggedIn);
}

/**
 * Returns an object containing the selections currently
 * in the betslip, using the DOM
 * @returns {Object} The list of selections
 */
export function getSelectionsIds() {
    return BetslipController.getSelectionsIds();
}

/**
 * Store the selection to redis and get the detail for the selection
 * @param {Array} selections eg: [{single: 1 || scorecast: [2, 3](optional)}]
 * @param {Object} gaComponent jQuery object
 * @param {Object} mouseClickPos Position of mouse pointer when user click
 * @param {Boolean} addToEnd  Add selections at the end of betslip list
 * @param {Boolean} shouldChangeView Should change to bet placement view
 * @param {Boolean} isDeepLinked Should check the flow through which selections are
 * @returns {void}
 */
export function addToBetslip(selections, gaComponent, mouseClickPos, addToEnd, shouldChangeView, isDeepLinked) {
    return BetslipController.add(
        selections, gaComponent, mouseClickPos, addToEnd, shouldChangeView, isDeepLinked
    );
}

/**
 * Add an entry to the BetLocateArray
 * @param {String} selectionId the selection id
 * @param {String} gaComponentName the GA component name
 * @returns {Void} Nothing at all
 */
export function betLocateAdd(selectionId, gaComponentName) {
    return BetslipController.betLocateAdd(selectionId, gaComponentName);
}

/**
 * Retrieve or pop an entry off the BetLocateArray
 * @param {String} selectionId the selection id the entry
 * @returns {(String|false)} The gaComponent name or Boolean false
 */
export function betLocatePop(selectionId) {
    return BetslipController.betLocatePop(selectionId);
}

/**
 * Close the betslip, but only if container size is not large.
 * @returns {void}
 */
export function closeBetslip() {
    if (!isLargeContainer()) {
        BetslipController.closeBetslip();
    }
}

/**
* Update the betslip openbet counter and the main header openbet counter
*
* @param {integer|boolean} value false to trigger a call to BE
*                                otherwise the counter
* @param {boolean} isIncrementValue value true to treat value as an increment.
*                                   if false, the given value will be set as counter
*
* @returns {void}
*/
export function updateOpenBetsCounter(value = false, isIncrementValue = true) {
    BetslipController.updateOpenBetsCounter(value, isIncrementValue);
}

/**
 * Reduces the open bets counter by one
 * @returns {void}
 */
export function decrementOpenBetsCounter() {
    const decrement = -1;

    updateOpenBetsCounter(decrement);
}

/**
 * Changes Betslip Tab to My Bets
 * @returns {void}
 */
export function openBetslipMyBetsTab() {
    if (!isLargeContainer()) {
        BetslipController.openBetslip();
    }

    BetslipController.selectMyBetsTab();
}

/**
 * Fires the callback when Available Freebets in state changed.
 * @param {Function} callback   Function which is run when state changed.
 * @return {void}
 */
export const onFreeBetsStateChange = (callback) => subscribeToStateChange(
    BETSLIP_AVAILABLE_FREEBETS_KEY,
    callback
);

/**
 * These keys are used for BabyBetslip to access the available freebets from the state
 */
export const FREEBETS_BET_TYPES = {
    'accumulator': 'multi_accumulator',
    'doubles': 'multi_doubles',
    'forecast': 'fc_tc_0',
    'scorecast': 'scorecast_0',
    'singles': 'single_0',
    'trebles': 'multi_trebles',
    'tricast': 'fc_tc_0',
};

/**
 * bet error ids mapping
 * these keys are used for localisation
 */
const BET_ERRORS = {
    DEFAULT_FALLBACK: 'your_bet_declined',
    INCOMPATIBLE_SELECTION: 'incompatible_sel',
    PRICE_CHANGED: 'price_changed',
    INVALID_FREE_BET: 'invalid_free_bet',
    SELF_TIMEDOUT: 'self_timedout',
    EACH_WAY_RESTRICTED: 'ew_restricted',
    SELECTION_EACH_WAY_UNAVAILABLE: 'sel_ew_unavailable',
    HORSE_NOT_TRADABLE: 'horse_not_tradable',
    CUSTOMER_SUSPENDED: 'cust_suspended',
    CUSTOMER_EXCEEDED_CUMULATIVE_MAX_STAKE: 'cust_exceeded_cumulative_max_stake',
    CUSTOMER_EXCEEDED_MAX_STAKE: 'exceeded_max_stake',
    CUSTOMER_EXCEEDED_MAX_STAKE_MULTIBET: 'exceeded_multi_max_stake',
    CUSTOMER_EXCEEDED_MAX_STAKE_EW: 'exceeded_max_stake',
    CUSTOMER_EXCEEDED_MIN_STAKE: 'exceeded_min_stake',
    CUSTOMER_EXCEEDED_MIN_STAKE_MULTIBET: 'exceeded_multi_min_stake',
    CUSTOMER_EXCEEDED_MIN_STAKE_EW: 'exceeded_min_stake',
    E_MTS_MAX_PAYOUT_EXCEEDED: 'exceeded_max_stake',
    E_MTS_CUSTOMER_LIABILITY_EXCEEDED: 'exceeded_max_stake',
    EACHWAY_DIVISOR_EXPIRED: 'ew_expired',
    EACHWAY_PLACES_EXPIRED: 'ew_expired',
    EVENT_STARTED: 'event_started',
    SELECTION_SUSPENDED_SINGLE: 'sel_suspended_single',
    SELECTION_SUSPENDED_MULTIBET: 'sel_suspended_multi',
    SELECTION_SUSPENDED_MTS: 'sel_suspended_multi',
    MAX_PAYOUT_EXCEEDED: 'max_payout_exceeded',
    MINIMUM_ODDS_NOT_REACHED: 'min_odds_not_reached',
};

/**
 * @param {String} key error id
 * @returns {String} i18n betslip bet error key
 */
export const getI18nBetErrorKey = key => BET_ERRORS[key] || BET_ERRORS['DEFAULT_FALLBACK'];

/**
 * Add selctions from deeplink into betslip and redirect to proper page
 * @param {Array} selectionIds array of selectionIds
 * @param {interger} surveyId int surveyId of the bet
 * @return {void}
 */
export function addToBetslipFromDeeplink(selectionIds, surveyId = null) {
    // add all selectionIds on betslip
    BetslipController.populateBetslip(selectionIds, surveyId);
}

/**
 * get the correct details for the forecast/tricast market
 * @param {Array} allBets array of all returned bets from placement
 * @param {Array} selectionIds array of selectionIds
 * @param {Array} details array of bet details
 * @return {String} the correct selection id
 */
export function getCastmarketId(allBets, selectionIds, details) {
    const detailsKeys = Object.keys(details);
    let selectionId = '';

    allBets.forEach(bet => {
        if (selectionIds.combinations.some(r=> bet.combinations.includes(r))) {
            const combo = bet.combinations.join('_');
            if (detailsKeys.includes(combo)) {
                selectionId = combo;
            }
        }
    });

    return selectionId;
}

/**
 * Iterates the selectionDetails from betslip in order to know
 * what is the selection-name involved on each bet, knowing its id
 *
 * @param {Object} selectionDetails map combinedSelectionsId to details
 * @returns {Object} map original-selectionid -> original-name
 */
export function getOriginalSelectionNamesById (selectionDetails) {
    return Object.keys(selectionDetails).reduce((acc, currCombinationId) => {
        if (selectionDetails[currCombinationId].is_cast_market) {
            const combinedSelectionsNames = selectionDetails[currCombinationId].selection_names;
            const combinedSelectionIds = currCombinationId.split('_');
            const newEntries = combinedSelectionIds.reduce((combAcc, sId, idx) => ({
                ...combAcc,
                [sId]: combinedSelectionsNames[idx],
            }), {});

            return {
                ...acc,
                ...newEntries,
            };
        }

        return acc;
    }, {});
}

/**
 * Counts selections that are NOT part of an fc_tc bet
 *
 * @param {Array} selections ordered selections
 * @returns {Number} count integer
 */
export function getNotFcTcSelectionsCount (selections) {
    const ZERO = 0;
    const ONE= 1;

    return selections.reduce(
        (acc, curr) => acc + ((curr[ZERO] && curr[ZERO].fc_tc) ? ZERO : ONE),
        ZERO,
    );
}

/**
 * Gets a map from fcTc newselectionid to an string with the
 * original runners ids underscore-separated
 *
 * @param {Array} bets from the bet-placement response error
 * @returns {Object} map
 */
export function getMapSelectionIdToCombinations (bets) {
    const ONE = 1;

    return bets.reduce((acc, {combinations, selection_ids: id}) => {
        if (combinations && combinations.length > ONE) {

            return {
                ...acc,
                [id]: combinations.join('_'),
            };
        }

        return acc;
    }, {});
}

/**
 * The selections in the error are keyed by id
 * if the selection exists in the map,
 * it means we need to use the underscored combination instead
 * Basically if the new-selection bet-id is 123 and is a combination og horse 45 and 67
 * then this will replace 123 key in the errors by 45_67
 *
 * @param {Object} error each error object in the bet-placement response error
 * @param {Object} mapSelectionIdToCombinations
 * map from fcTc newselectionid -> string combinations of underscore separated
 * @returns {Object} selections with ids replaced
 */
export function getSelectionSuspendedSingle (error, mapSelectionIdToCombinations) {
    const newSelections = Object.keys(error.data.selections).reduce((acc, selectionId) => {
        const combinationKey = mapSelectionIdToCombinations[selectionId];
        const newItem = combinationKey ? {
            [combinationKey]: error.data.selections[selectionId],
        }: {
            [selectionId]: error.data.selections[selectionId],
        };

        return {
            ...acc,
            ...newItem,
        };
    }, {});

    const currentErrorData = {
        ...error.data,
        selections: newSelections,
    };

    return {
        ...error,
        data: currentErrorData,
    };
}

/**
 * Should display regulation tax message
 * @returns {Boolean} true if we should display tax message, false otherwise
 */
export const shouldDisplayTaxMessage = () => Boolean(getUserTaxOnReturns());

/**
 * Returns tax with percentage
 * @returns {String} eg: 5%
 */
export const getUserTaxOnReturnsForDisplay = () => {
    const tax = getUserTaxOnReturns();
    const percentage = 100;

    return tax ? `${bsNumber(tax * percentage)}%` : '';
};

/**
 * Changes the Baby Betslip Positioning based on cookie banner visibility
 * @param {Object} cookieBannerVisibility Object with cookie banner visibility data
 * @return {void}
 */
export function changeBabyBetslipPosition(cookieBannerVisibility) {
    BetslipController.changeBabyBetslipPosition(cookieBannerVisibility);
}

/**
 * Decides whether to hide/display accept odds changes section
 * @param {boolean} hasSelections whether selections exist in betslip
 * @return {void}
 */
export function showHideAcceptOdds(hasSelections = false) {
    const betslipOddsToggle = document.querySelector('#betslipOddsToggle-betslip');
    const shouldShow = hasSelections && isUserLoggedIn();

    betslipOddsToggle.classList.toggle('betslipOddsToggle--hidden', !shouldShow);
    const toggleSwitch = betslipOddsToggle.querySelector('.betslipOddsToggle__switch');
    toggleAcceptOdds(toggleSwitch);
}

/**
 * Toggles class and html attribute in the given switch element
 * @param {Object} toggleSwitch html element
 * @returns {void}
 */
export const toggleAcceptOdds = (toggleSwitch) => {
    const customerOddsFlag = getCustomerAcceptOddsFlag();
    const gtmAttributeParts = toggleSwitch.dataset.spectateProduct.split(';');
    const toggleGtmPart = `${gtmAttributeParts[0]};${gtmAttributeParts[1]};`;
    const toggleGtmStatus = customerOddsFlag ? 'accept-odds-movement-off' : 'accept-odds-movement-on';
    toggleSwitch.classList.toggle('betslipOddsToggle__switch--active', customerOddsFlag);
    toggleSwitch.dataset.oddsToggle = customerOddsFlag;
    toggleSwitch.dataset.spectateProduct = `${toggleGtmPart}${toggleGtmStatus}`;
};

/**
 * Toggles class and html attribute in all elements
 * @returns {void}
 */
export const toggleAcceptOddsAllSwitches = () => {
    const switches = document.querySelectorAll('.betslipOddsToggle .betslipOddsToggle__switch');
    switches.forEach(toggleAcceptOdds);
};

/**
 * Set the value of the accept odds flag
 * @param {boolean} oddsFlag the value of the odds acceptance flag to be set
 * @return {void}
 */
export function setAcceptOddsFlag(oddsFlag = false) {
    const url = buildSpectateUrl('/oddsacceptrequest/update');
    const requestParams = {
        accept_odds_change: oddsFlag,
    };

    return post(url, requestParams).then(response => {
        return response;
    });
}

/**
 * Given the updated selections-details, recreates the
 * availableBetTypes with the updated odds
 *
 * @param {Object} selectionsDetails id-keyed object with selections info
 * @param {Object} availableBetTypes original data to update
 *
 * @returns {Object} updated availableBetTypes
 */
export const getUpdatedMultipleOdds = (selectionsDetails, availableBetTypes) => {
    const newPrices = getUpdatedPricesList(selectionsDetails);

    return calculateAllMultipleOdds(newPrices, availableBetTypes);
};

/**
 * Given the updated selections-details
 * returns the list of updated prices in the betslip selections
 *
 * @param {Object} selectionsDetails id-keyed object with selections info
 * @returns {Array} of updated prices
 */
export const getUpdatedPricesList = selectionsDetails =>
    Object.keys(selectionsDetails)
        .map(id => selectionsDetails[id].decimal_price);

/**
 * Given the updated prices, recreates the
 * availableBetTypes with the updated odds
 *
 * @param {Array} prices to combine
 * @param {Object} availableBetTypes structureName => structure-detail
 *
 * @returns {Array} of updated availableBetTypes
 */
export const calculateAllMultipleOdds = (prices, availableBetTypes) => {
    const isSP = !(prices.every(price => !isNull(price)));

    return Object.keys(availableBetTypes).reduce((acc, structureName) => {
        const betType = availableBetTypes[structureName];
        const newOdds = isSP ? null :
            calculateMultipleOdds(prices, betType.breakdown);

        return ({
            ...acc,
            [structureName]: {
                ...betType,
                potential_returns_multiplier: newOdds,
            },
        });
    }, {});
};

/**
 * Process prices combinations and calculate the odds
 * for the given breakdown
 *
 * @param {Array} prices to combine
 * @param {Array} breakdown of bet structures
 * @returns {Number} odds
 */
export const calculateMultipleOdds = (prices, breakdown = []) => {
    const newOdds = breakdown.reduce((accTotal, {id}) => {
        const unitSize = id || prices.length;
        const combinations = getCombinations(prices, unitSize);

        return combinations.reduce((accComb, currComb) =>
            accComb + getProduct(currComb), accTotal);
    }, 0);

    return bsNumber(newOdds);
};

/**
 * Generates all the possible combinations of combinationSize length
 * given a set of elements. For instance, when all
 * combinable elements are [A, B, C, D] and size is 2
 * then output should be AB AC AD BC BD CD
 *
 * @param {Array} elementsToCombine all combinable elements
 * @param {Number} combinationSize the size of the combinations we want
 * @returns {Array} of combinations
 */
export const getCombinations = (elementsToCombine, combinationSize) => {
    const combinations = [];
    generateCombinations([], 0, elementsToCombine, combinations, combinationSize);

    return combinations;
};

/**
 * Recursively generates combinations
 *
 * @param {Array} combination the current combination of prices
 * @param {Number} i index of the current combination
 * @param {Array} elementsToCombine all combinable elements
 * @param {Array} combinations accumulator (this is the output;
 * it is passed by reference!!)
 * @param {Number} combinationSize the size of the combinations we want
 * @returns {void}
 */
const generateCombinations = (combination, i, elementsToCombine, combinations, combinationSize) => {
    if (combination.length !== combinationSize) {
        const next = i + 1;
        if (next <= elementsToCombine.length) {
            const newCombination = [
                ...combination,
                elementsToCombine[i],
            ];
            generateCombinations(newCombination, next, elementsToCombine, combinations, combinationSize);
            generateCombinations(combination, next, elementsToCombine, combinations, combinationSize);
        }
    } else {
        combinations.push(combination);
    }
};

/**
 * Multiply all the given numbers
 *
 * @param {Array} list the numbers to multiply
 * @returns {Number} all the numbers multiplied
 */
const getProduct = list => list.reduce((acc, curr) => (acc * curr), 1);
